import React, { useState } from 'react';
import { Table, Collapse, Card, Button, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDesignerStats } from '../hooks/useDesignerStats';

// Chevron icon with rotate animation
const ChevronIcon = ({ isOpen }) => (
  <span
    style={{
      display: 'inline-block',
      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.2s ease'
    }}
  >
    ▼
  </span>
);

// ✅ Child component for conditionally fetching and showing designer stats
const DesignerRowDetails = ({ designerId }) => {

  const { isLoading, isError, error, data } = useDesignerStats(designerId);

    // console.log("desID", data.ongoingProjects);

  if (isLoading) return <p>Loading projects...</p>;
  if (isError) return <p className="text-danger">Error: {error.message}</p>;

  if (!data?.ongoingProjects?.length) {
    return <p className="text-muted mb-0">No Projects available</p>;
  }

  return (
    <Table size="sm" className="mb-0 rounded overflow-hidden" hover>
      <thead className="table-secondary">
        <tr>
          <th className="px-3 py-3 text-start text-uppercase small fw-semibold">Project Name</th>
          <th className="px-3 py-3 text-start text-uppercase small fw-semibold">Completion (%)</th>
          <th className="px-3 py-3 text-start text-uppercase small fw-semibold">Current Task</th>
        </tr>
      </thead>
      <tbody>
        {data.ongoingProjects.map((record, index) => (
          <tr key={index}>
            <td className="px-3 py-3">{record.projectName}</td>
            <td className="px-3 py-3">{record.completedStagePercentage}</td>
            <td className="px-3 py-3">{record.currentActiveTask}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

const CollapsibleTable = ({ designerData, loading }) => {
  const [openItems, setOpenItems] = useState({});

  const toggleCollapse = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const tableStyles = {
    container: {
      overflowX: 'auto',
      border: '1px solid #dee2e6',
      borderRadius: '0.375rem',
      backgroundColor: 'white',
      padding: 0
    },
    table: {
      marginBottom: 0,
      borderRadius: '0.375rem'
    }
  };

  return (
    <div style={tableStyles.container}>
      <Card>
        <Card.Body className="p-0">
          <table className="table table-hover rounded overflow-hidden" style={tableStyles.table}>
            <thead className="table-light">
              <tr>
                <th style={{ width: '40px' }}></th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">Designer Name</th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">Total Projects</th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">Ongoing Projects</th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">Completed Projects</th>
              </tr>
            </thead>
            <tbody>
              {designerData?.data?.map((designer) => {
                const isOpen = openItems[designer.id] || false;

                return (
                  <React.Fragment key={designer.id}>
                    <tr>
                      <td className="px-3 py-3">
                        <Button
                          variant="link"
                          className="p-0 border-0 text-muted"
                          onClick={() => toggleCollapse(designer.id)}
                          style={{ fontSize: '12px' }}
                        >
                          <ChevronIcon isOpen={isOpen} />
                        </Button>
                      </td>
                      <td className="px-3 py-3">{designer.name}</td>
                      <td className="px-3 py-3">{designer.stats.total}</td>
                      <td className="px-3 py-3">{designer.stats.ongoing}</td>
                      <td className="px-3 py-3">{designer.stats.completed}</td>
                    </tr>
                    <tr>
                      <td colSpan="6" className="p-0 border-0">
                        <Collapse in={isOpen}>
                          <div>
                            <Card className="border-0 rounded-0">
                              <Card.Body className="bg-light">
                                <h6 className="mb-3">Projects</h6>
                                {isOpen && <DesignerRowDetails designerId={designer.id} />}
                              </Card.Body>
                            </Card>
                          </div>
                        </Collapse>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CollapsibleTable;
